module.exports = __webpack_public_path__ + "img/misteryBox.2be2da85.png";